import React from 'react'
import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'

import _ from 'lodash'

function DisplayAnswerItems({ answerData, noDataMessage, funcBuildItem }) {
  if (_.isEmpty(answerData)) {
    return <p>A questão ainda não foi respondida.</p>
  }
  if (_.isEmpty(answerData?.items)) {
    return <p>{noDataMessage}</p>
  }

  return (
    <React.Fragment>
      {addKeyToObjectsArray(answerData.items).map((item) => funcBuildItem(item))}
    </React.Fragment>
  )
}

export default DisplayAnswerItems
